/**
 * @generated SignedSource<<51e59ff79faedd102b8d75d839c1f674>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type livePageLatestContent$data = {
  readonly contents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"livePrimaryContentItemContent">;
      };
    }>;
  };
  readonly " $fragmentType": "livePageLatestContent";
};
export type livePageLatestContent$key = {
  readonly " $data"?: livePageLatestContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"livePageLatestContent">;
};

import livePageLatestPaginationQuery_graphql from './livePageLatestPaginationQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "contents"
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "applicationIds"
    },
    {
      "defaultValue": 30,
      "kind": "LocalArgument",
      "name": "count"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "excludeArticleTypeIds"
    },
    {
      "defaultValue": [],
      "kind": "LocalArgument",
      "name": "excludeSectionIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "scmpPlusPaywallTypeIds"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "count",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "count",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": livePageLatestPaginationQuery_graphql
    }
  },
  "name": "livePageLatestContent",
  "selections": [
    {
      "alias": "contents",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "articleTypeIds",
              "variableName": "excludeArticleTypeIds"
            },
            {
              "kind": "Variable",
              "name": "paywallTypeIds",
              "variableName": "scmpPlusPaywallTypeIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "articleExcludeInput"
        },
        {
          "kind": "Literal",
          "name": "articleFilterInput",
          "value": {
            "sponsorTypes": [
              "NONE"
            ]
          }
        },
        {
          "kind": "Literal",
          "name": "contentTypes",
          "value": [
            "ARTICLE",
            "GALLERY",
            "VIDEO"
          ]
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "sectionIds",
              "variableName": "excludeSectionIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "applicationIds",
              "variableName": "applicationIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ContentConnection",
      "kind": "LinkedField",
      "name": "__livePage__article_contents_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "livePrimaryContentItemContent"
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "cb9d02d087f05aeeec5ffdb74ddd0794";

export default node;
